
<div class="confirm-dialog-surface">
    <div class="confirm-dialog-header">
        <mat-icon class="header-icon">{{ icon }}</mat-icon>
        <h2 class="confirm-dialog-title">{{ titulo }}</h2>
    </div>

    <div class="confirm-dialog-content">
        <p class="confirm-dialog-msg">{{ msj }}</p>
        <div *ngIf="data?.toggle" class="confirm-dialog-toggle">
            <mat-slide-toggle color="accent"
                [(ngModel)]="data.toggle!.valor" (change)="data.toggle!.cambio?.($event.checked)"
                [matTooltip]="data.toggle!.tooltip ?? ''">
                {{ data.toggle!.etiqueta }}
            </mat-slide-toggle>
            <span *ngIf="data.toggle!.detalle" class="confirm-dialog-toggle-detalle">
                {{ data.toggle!.detalle(data.toggle!.valor) }}
            </span>
        </div>
    </div>

    <div class="confirm-dialog-actions">
        <button *ngIf="!ocultarCancelar" mat-stroked-button (click)="cancelar()">
            {{ botonCancelar }}
        </button>
        <button mat-flat-button [color]="destructivo ? 'warn' : 'primary'" (click)="aceptar()">
            {{ botonAceptar }}
        </button>
    </div>
</div>

